import Rarity from '../types/Rarity';

const RARITY: {
  [key in Rarity]: { light: string; normal: string; dark: string };
} = {
  N: {
    light: '#1ce061',
    normal: '#1ce061',
    dark: '#093a1f',
  },
  R: {
    light: '#1cb5e0',
    normal: '#1cb5e0',
    dark: '#040429',
  },
  SR: {
    light: '#6a3093',
    normal: '#6a3093',
    dark: '#130423',
  },
  SSR: {
    light: '#ff3520',
    normal: ' #ff3520',
    dark: '#5f0b15',
  },
  UR: {
    light: '#ffd400',
    normal: '#ffd400',
    dark: '#79440d',
  },
};

export default {
  SPACING: 8,
  COLORS: {
    TEXT: 'white',
    PRIMARY: '#1a293b',
    RARITY,
  },
};
